import React from 'react';
import { SmlsButton, SmlsModal } from '@smiles/smiles-ui-kit-react';
import { ModalBody, ModalFooter } from 'reactstrap';
import { TangModalHeader } from '../components/TangModalHeader';
import { LoginModal, useLoginModalFlow } from '../context/LoginModalFlowContext';
import { ImageModalCircle } from '../assets/ImageModalCircle';

export function GenericErrorModal() {
  const modalFlow = useLoginModalFlow();

  function toggleModal() {
    modalFlow.closeModal(LoginModal.ERROR_GENERIC)
  }
  
  return (
    <SmlsModal
      type="right"
      isOpen={modalFlow.isModalOpen(LoginModal.ERROR_GENERIC)}
      className="tang-modal"
      toggle={toggleModal}
      defaultHeader={false}
    >
      <TangModalHeader showCloseButton onClose={toggleModal} />
      <ModalBody data-testid="modal-body">
        <div className="modal-content">
          <div> 
            <div className="modal-icon">
              <ImageModalCircle />
            </div>
            <p className="modal-title">Vamos tentar novamente ?</p>
            <p className="modal-subtitle">
              Ocorreu um problema com o sistema e não conseguimos carregar esta página.
            </p>
          </div>
        </div>
      </ModalBody>
      <ModalFooter className='one-button'>
        <SmlsButton className="button" text="Tentar novamente" onClick={toggleModal} />
      </ModalFooter>
    </SmlsModal>
  );
}
